import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        opacity="0.4"
        d="M11.1199 20.78C11.1199 20.78 7.49992 22.38 5.83992 29.33C3.86992 37.56 5.07992 49.43 1.42992 54.91C1.42992 54.91 -1.78008 33.57 3.99992 20.97L11.1199 20.78Z"
        fill={fill}
      />
      <path
        opacity="0.4"
        d="M39.23 20.78C39.23 20.78 42.85 22.38 44.51 29.33C46.48 37.56 45.27 49.43 48.92 54.91C48.92 54.91 52.13 33.57 46.35 20.97L42.56 19.35L39.23 20.78Z"
        fill={fill}
      />
      <path
        d="M4.72988 20.54C4.72988 20.54 1.90989 7.85001 12.8499 3.17001C22.4899 -0.949989 33.9399 5.22003 48.4499 4.82003C49.4599 7.04004 47.6399 7.24001 46.6399 9.86001C48.4499 10.46 51.8799 10.46 51.8799 10.46L47.9699 14.19C47.9699 14.19 51.4799 17.11 51.2799 20.94C51.0799 24.77 49.6699 26.98 49.6699 26.98C49.6699 26.98 48.4599 20.33 42.4199 19.93C37.7999 19.62 34.5999 22 25.6999 21.95C20.2299 21.91 11.0499 20.14 11.0499 20.14L4.72988 20.54Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6399 21.58C19.1599 20.13 20.0199 18.8101 21.0199 17.6301C22.0199 16.4401 23.2199 15.4201 24.5499 14.5601C25.8799 13.7101 27.3699 13.1201 28.9199 12.8101C30.4499 12.4501 32.0599 12.5601 33.5499 12.8801C32.0299 13.1901 30.5899 13.4001 29.2299 13.9401C27.8699 14.4401 26.5599 15.03 25.3499 15.83C22.8899 17.36 20.7399 19.35 18.6399 21.58Z"
        fill={outline}
      />
      <path
        d="M35.17 17.8299C33.42 18.3999 31.77 18.9499 30.21 19.7199C29.42 20.0899 28.7 20.5499 27.98 21.0399C27.27 21.5399 26.64 22.1399 25.97 22.7899C26.28 21.9299 26.79 21.11 27.47 20.45C28.14 19.79 28.92 19.2399 29.76 18.8299C30.61 18.4299 31.49 18.1199 32.41 17.9599C33.32 17.7799 34.25 17.7099 35.17 17.8299Z"
        fill={outline}
      />
      <path
        d="M22.97 21.38C24.15 19.16 26.06 17.29 28.32 16.08C30.55 14.81 33.07 14.1201 35.59 13.7601C38.12 13.4401 40.69 13.43 43.2 13.87C45.68 14.32 48.24 15.14 50.07 16.92C49.05 16.19 47.9 15.7 46.71 15.36C45.53 14.99 44.32 14.7601 43.09 14.6401C40.64 14.3901 38.16 14.4301 35.72 14.7601C33.28 15.0901 30.89 15.71 28.67 16.77C28.1 17 27.59 17.3501 27.05 17.6401C26.56 18.0001 26.02 18.31 25.56 18.73C24.56 19.44 23.78 20.41 22.97 21.38Z"
        fill={outline}
      />
      <path
        d="M16.6599 20.8C16.6599 20.8 19.8299 10.65 29.7899 10.45C39.1899 10.26 44.8399 14.09 51.0799 10.86"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M48.25 5.63C48.25 5.63 46.44 8.70999 30.12 8.04999C15.21 7.44999 14.97 19.93 14.97 21.03"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M10.0598 20.37C9.89979 19.32 9.86978 18.39 9.92978 17.42C9.94978 16.94 10.0198 16.46 10.0698 15.98C10.1698 15.51 10.2398 15.03 10.3598 14.57C10.8398 12.71 11.6698 10.93 12.8998 9.47998C13.1698 9.08998 13.5498 8.79001 13.8698 8.45001L14.3698 7.95001L14.9298 7.51996C15.3098 7.24996 15.6598 6.94001 16.0598 6.70001L17.2798 6.01996C17.6698 5.76996 18.1098 5.61001 18.5398 5.45001L19.8198 4.94C20.6998 4.68 21.5898 4.46998 22.4698 4.22998C21.6098 4.54998 20.7498 4.83999 19.9098 5.17999L18.6998 5.78998C18.2998 5.98998 17.8898 6.17996 17.5298 6.45996L16.4198 7.21997C16.0598 7.47997 15.7498 7.80998 15.4198 8.09998L14.9298 8.53998L14.5098 9.04999C14.2398 9.39999 13.9198 9.69997 13.6998 10.09C12.6898 11.52 12.0998 13.19 11.8198 14.89C11.5498 16.57 11.6298 18.39 11.9998 19.94L10.0598 20.37Z"
        fill={outline}
      />
      <path
        d="M7.83975 21.24C7.83975 21.24 5.72974 6.62998 18.4297 1.59998"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M40.6499 19.54C40.6499 19.54 47.4499 14.3 51.2799 22.36" stroke={outline} strokeMiterlimit="10" />
    </g>
  )
}
